import {
  getUserData,
  saveGroup,
  getGroupDetail,
  updateGroup
} from '@/axios/api/userGroup'
import { Message } from 'element-ui'

const UPDATE_TBL_LOADING = 'UPDATE_TBL_LOADING'
const UPDATE_DET_LOADING = 'UPDATE_DET_LOADING'
const UPDATE_TABLEDATA = 'UPDATE_TABLEDATA'
const UPDATE_TOTAL = 'UPDATE_TOTAL'
const UPDATE_PARAMS = 'UPDATE_PARAMS'
const UPDATE_SEARCH = 'UPDATE_SEARCH'
const UPDATE_USER = 'UPDATE_USER'
const UPDATE_DETAIL = 'UPDATE_DETAIL'

const state = {
  tableData: [],
  tblLoading: false,
  detailLoading: false,
  pager: {
    current: 1,
    size: 10,
    total: 0
  },
  params: {
    groupName: '',
    dataStatus: ''
  },
  userList: [],
  detail: {
    userIds: [],
    dataStatus: '',
    groupName: ''
  }
}

const getters = {
  tableData: state => state.tableData,
  userList: state => state.userList.map(v => {
    return {
      label: v.name,
      value: v.id
    }
  }),
  tblLoading: state => state.tblLoading,
  detailLoading: state => state.detailLoading,
  pager: state => state.pager,
  params: state => state.params,
  detail: state => state.detail
}

const mutations = {
  [UPDATE_TABLEDATA] (state, tableData) {
    state.tableData = tableData
  },
  [UPDATE_TBL_LOADING] (state, tblLoading) {
    state.tblLoading = tblLoading
  },
  [UPDATE_TOTAL] (state, total) {
    state.pager = { ...state.pager, total }
  },
  [UPDATE_PARAMS] (state, params) {
    state.params = { ...state.params, params }
  },
  [UPDATE_SEARCH] (state, { pager, params }) {
    state.pager = { ...state.pager, ...pager }
    if (params) state.params = params
  },
  [UPDATE_DET_LOADING] (state, detailLoading) {
    state.detailLoading = detailLoading
  },
  [UPDATE_USER] (state, userList) {
    state.userList = userList
  },
  [UPDATE_DETAIL] (state, detail) {
    state.detail = detail
  }
}

const actions = {
  setParamsApi ({commit}, params) {
    commit(UPDATE_PARAMS, params)
  },
  async getUserDataApi ({commit}, params) {
    try {
      const { data: res } = await getUserData(params)
      commit(UPDATE_USER, res)
    } catch (e) {}
  },
  // 设置page
  setPagerApi ({commit}, pager) {
    commit(UPDATE_SEARCH, { pager })
  },
  // 新增保存用户组
  async saveGroupApi ({commit}, params) {
    commit(UPDATE_DET_LOADING, true)
    try {
      await saveGroup(params)
      Message.success('success')
      commit(UPDATE_DET_LOADING, false)
      return true
    } catch (e) {
      commit(UPDATE_DET_LOADING, false)
      return false
    }
  },
  // 更新用户组信息
  async updateGroupApi ({commit}, params) {
    commit(UPDATE_DET_LOADING, true)
    try {
      await updateGroup(params)
      Message.success('success')
      commit(UPDATE_DET_LOADING, false)
      return true
    } catch (e) {
      commit(UPDATE_DET_LOADING, false)
      return false
    }
  },
  async getGroupDetailApi ({commit}, params) {
    commit(UPDATE_DET_LOADING, true)
    try {
      const { data: res } = await getGroupDetail(params)
      commit(UPDATE_DETAIL, res)
    } catch (e) {}
    commit(UPDATE_DET_LOADING, false)
  },
  // 清空搜索条件
  clearSearchApi ({state, commit}) {
    const pager = {
      ...state.pager,
      current: 1
    }
    const params = {
      ...state.params,
      groupName: '',
      dataStatus: ''
    }
    commit(UPDATE_SEARCH, { pager, params })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/userGroup.js